import React from 'react';

/**
 * Button component with various styles and states
 */
const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  type = 'button',
  disabled = false,
  isLoading = false,
  fullWidth = false,
  className = '',
  ...props 
}) => {
  // Base styles
  const baseStyles = 'rounded-md transition-all duration-200 focus:outline-none';
  
  // Size styles
  const sizeStyles = {
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2',
    large: 'px-6 py-3 text-lg'
  };
  
  // Variant styles
  const variantStyles = {
    primary: `bg-[#7e55f6] text-white hover:bg-[#6a46d1] ${disabled ? 'opacity-50 cursor-not-allowed' : 'shadow-md hover:shadow-lg'}`,
    secondary: `bg-[#333333] text-white hover:bg-[#444444] ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    outline: `border border-[#7e55f6] text-[#7e55f6] bg-transparent hover:bg-[#7e55f6] hover:bg-opacity-10 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    ghost: `text-[#7e55f6] bg-transparent hover:bg-[#7e55f6] hover:bg-opacity-10 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    danger: `bg-red-600 text-white hover:bg-red-700 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`
  };
  
  // Width style
  const widthStyle = fullWidth ? 'w-full' : '';
  
  // Combine styles
  const buttonStyles = `${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${widthStyle} ${className}`;
  
  return (
    <button
      type={type}
      className={buttonStyles}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>Please wait...</span>
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;